import type { Loop } from '../../services/loopService';

const createdTime = (loop: Loop): number => {
  const value = Date.parse(loop.created_at);

  return Number.isFinite(value) ? value : 0;
};

// Match the API's stable ordering, including loops created in the same second.
export const newestLoopsFirst = (loops: Loop[]): Loop[] => [...loops].sort((left, right) => (
  createdTime(right) - createdTime(left) || right.id.localeCompare(left.id)
));
